<template>
  <div class="part-row">
    <div class="row mt-1">
      <div class="col-md-12 table-responsive">
        <input v-model="title" class="form-control part-title mb-2" type="text" name="guide_item_titles[]" />
        <table class="table table-bordered">
          <tr>
            <th class="text-left">
              <div class="btn-group">
                <label
                  v-for="guideItemTypeRadio in guideItemTypeRadios"
                  :key="guideItemTypeRadio.type"
                  :for="'guide-id' + id + 'guide-item-type-' + guideItemTypeRadio.type"
                  class="btn radio-inline"
                >
                  <input
                    :id="'guide-id' + id + 'guide-item-type-' + guideItemTypeRadio.type"
                    v-model="type"
                    type="radio"
                    :value="guideItemTypeRadio.type"
                    :name="type + id"
                  />
                  {{ guideItemTypeRadio.name }}
                </label>
              </div>
            </th>
            <td class="text-left">
              <input v-model="itemId" class="form-control" type="text" />
            </td>
          </tr>
        </table>
        <hr class="mb-2" />
      </div>

      <input id="delete" type="button" class="btn remove-part" value="목차 삭제" @click="emitDeleteGuideItem()" />
      <input type="button" class="btn up-part" value="▲" @click="emitUpGuideItem()" />
      <input type="button" class="btn down-part" value="▼" @click="emitDownGuideItem()" />
    </div>

    <div class="row">
      <div class="col-md-12">
        <ckeditor v-model="description" :editor="editor" :config="editorConfig" @ready="attachInspector"></ckeditor>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import inlineEditorConfig from '../mixins/InlineEditorConfig';
import { EventBus } from '../event-bus.js';
import helpers from '../helpers/helpers';

export default {
  mixins: [inlineEditorConfig],
  props: ['id'],
  data() {
    return {
      guideItemTypeRadios: [
        {
          type: 1,
          name: '웹북/아티클',
        },
        {
          type: 2,
          name: '챕터',
        },
      ],
    };
  },
  computed: {
    title: {
      get() {
        return this.$store.state.guideEditor.guideItems[this.id].title;
      },
      set(value) {
        this.$store.commit('updateGuideItemEditorTitle', {
          editorId: this.id,
          title: value,
        });
        EventBus.$emit('setIsSavedGuide', false);
      },
    },
    description: {
      get() {
        return this.$store.state.guideEditor.guideItems[this.id].description || '';
      },
      set(value) {
        this.commitUpdateGuideItemEditorDescriptionDebounced(value);
        EventBus.$emit('setIsSavedGuide', false);
      },
    },
    type: {
      get() {
        return this.$store.state.guideEditor.guideItems[this.id].type;
      },
      set(value) {
        this.$store.commit('updateGuideItemEditorType', {
          editorId: this.id,
          type: value,
        });
        EventBus.$emit('setIsSavedGuide', false);
      },
    },
    itemId: {
      get() {
        return this.$store.state.guideEditor.guideItems[this.id].itemId;
      },
      set(value) {
        this.$store.commit('updateGuideItemEditorItemId', {
          editorId: this.id,
          itemId: value,
        });
        EventBus.$emit('setIsSavedGuide', false);
      },
    },
  },
  methods: {
    emitDeleteGuideItem() {
      this.$parent.$emit('deleteGuideItem', this.id);
    },

    commitUpdateGuideItemEditorDescriptionDebounced: _.debounce(function (value) {
      this.$store.commit('updateGuideItemEditorDescription', {
        editorId: this.id,
        description: helpers.replaceSmartQuotes(value),
      });
    }, 100),

    emitUpGuideItem() {
      this.$parent.$emit('upGuideItem', this.id);
    },
    emitDownGuideItem() {
      this.$parent.$emit('downGuideItem', this.id);
    },
  },
};
</script>
